/* KD9 — Translation dictionaries for ES / EN */

export const translations = {
  es: {
    // nav
    "nav.inicio": "Inicio",
    "nav.diagnosticos": "Diagnóstico",
    "nav.academia": "Academia",
    "nav.acompanamiento": "Acompañamiento",
    "nav.marketplace": "Marketplace",
    "nav.sobre": "Quiénes Somos",
    "nav.contacto": "Contacto",
    "nav.login": "Iniciar Sesión",
    "nav.register": "Crear Cuenta",

    // hero
    "hero.kicker": "Plataforma KD9 · Despierta lo ancestral",
    "hero.title": "KHAOS DELTA 9",
    "hero.tagline": "La energía que despierta lo ancestral",
    "hero.subtitle":
      "Conocimiento ancestral, acompañamiento humano, diagnósticos personalizados y tecnología — integrados en una sola experiencia para guiar tu camino de transformación.",
    "hero.cta.solicitar": "Solicitar Diagnóstico",
    "hero.cta.consulta": "Consulta Rápida",
    "hero.cta.tienda": "Explorar Marketplace",

    // landing sections
    "section.diagnosticos": "Nuestros Diagnósticos",
    "section.process": "Más que una consulta, es un proceso de claridad",
    "section.how": "¿Cómo funciona?",
    "section.whatis": "¿Qué es KHAOS DELTA 9?",
    "section.acompanamiento": "Acompañamiento Humano",
    "section.academia": "Academia KD9",
    "section.marketplace": "Marketplace KD9",
    "section.cta": "Tu proceso empieza cuando decides mirar hacia adentro.",

    "landing.badge.geometry": "Geometría sagrada",
    "landing.badge.vision": "Visión interior",
    "landing.badge.nature": "Naturaleza",
    "landing.studies": "Nuestros estudios",
    "landing.process.personalized": "Diagnósticos personalizados",
    "landing.process.professional": "Interpretación profesional",
    "landing.process.spiritual": "Integración espiritual y terapéutica",
    "landing.process.delivery": "Entrega clara y estructurada",
    "landing.step.1.title": "Elige tu estudio",
    "landing.step.1.desc": "Selecciona el estudio que necesitas.",
    "landing.step.2.title": "Completa tu información",
    "landing.step.2.desc": "Llena tus datos para personalizar tu estudio.",
    "landing.step.3.title": "Recibe tu diagnóstico",
    "landing.step.3.desc": "Nuestro equipo analiza y entrega tu estudio.",
    "landing.step.4.title": "Aplica tu proceso",
    "landing.step.4.desc": "Integra y transforma tu energía.",
    "landing.academy.subtitle": "Aprende, entiende y transforma tu energía.",
    "landing.shop.title": "TIENDA KD9",
    "landing.shop.subtitle": "Productos creados por nuestra comunidad.",
    "landing.shop.cta": "Entrar a la tienda",
    "landing.final": "TU PROCESO EMPIEZA|CUANDO DECIDES MIRAR|HACIA ADENTRO.",
    "landing.create": "Crear cuenta ahora",
    "contact.whatsappSend": "Enviar por WhatsApp",
    "contact.phoneWhatsapp": "Teléfono y WhatsApp",
    "contact.location": "Ubicación",
    "contact.whatsappStart": "Iniciar conversación por WhatsApp",

    // what is
    "whatis.khaos.title": "KHAOS",
    "whatis.khaos.desc": "Transformación",
    "whatis.delta.title": "DELTA",
    "whatis.delta.desc": "Cambio",
    "whatis.nine.title": "9",
    "whatis.nine.desc": "Integración",
    "whatis.message": "La energía que despierta lo ancestral.",

    // acompañamiento
    "acomp.kicker": "Acompañamiento KD9",
    "acomp.title": "No estás solo en el proceso.",
    "acomp.subtitle":
      "Personas reales, profesionales y guías ancestrales — disponibles cuando necesites escuchar y ser escuchado.",
    "acomp.hablar": "Hablar con alguien",
    "acomp.hablar.desc": "Conversación directa con un consultor KD9.",
    "acomp.video": "Videollamada",
    "acomp.video.desc": "Sesión privada por video con un guía.",
    "acomp.escuchado": "Necesito ser escuchado",
    "acomp.escuchado.desc": "Un espacio sin juicio, en cualquier momento.",
    "acomp.agendar": "Agendar acompañamiento",
    "acomp.agendar.desc": "Programa una sesión profunda con tu consultor.",

    // about
    "about.kicker": "Quiénes Somos",
    "about.title": "Donde lo ancestral y lo tecnológico se encuentran",
    "about.body":
      "KHAOS DELTA 9 nace como un ecosistema que integra conocimiento ancestral, acompañamiento humano y tecnología para acercar procesos de transformación a las personas.",
    "about.mision.title": "Misión",
    "about.mision.body":
      "Acompañar procesos humanos mediante diagnósticos personalizados, educación, comunidad y acompañamiento profesional.",
    "about.vision.title": "Visión",
    "about.vision.body":
      "Convertirse en una plataforma integral donde tecnología y conocimiento ancestral coexistan.",
    "about.valores": "Valores",
    "val.humanidad": "Humanidad",
    "val.etica": "Ética",
    "val.acompanamiento": "Acompañamiento",
    "val.conocimiento": "Conocimiento",
    "val.responsabilidad": "Responsabilidad",
    "val.evolucion": "Evolución",

    // diagnóstico cards
    "diag.egipcio.name": "Diagnóstico Egipcio",
    "diag.egipcio.desc": "Conexión con tu alma ancestral y propósito de vida.",
    "diag.esencial.name": "Diagnóstico Esencial",
    "diag.esencial.desc": "Análisis energético esencial para tu bienestar.",
    "diag.holistico.name": "Diagnóstico Holístico",
    "diag.holistico.desc": "Evaluación completa de tu energía, cuerpo, mente y espíritu.",
    "diag.terreno.name": "Diagnóstico Terreno",
    "diag.terreno.desc": "Análisis de tu entorno y conexiones terrenales.",
    "diag.maestro.name": "Diagnóstico Maestro KD9",
    "diag.maestro.desc": "El estudio más completo y profundo de todos los niveles.",
    "diag.consulta.name": "Consulta Rápida",
    "diag.consulta.desc": "Resuelve dudas puntuales con un consultor disponible.",
    "diag.cta": "Solicitar",
    "diag.from": "Desde",

    // academia
    "academia.title": "Academia KD9",
    "academia.body":
      "Cursos, formaciones, talleres, aprendizaje y certificaciones — todo en un mismo espacio para tu evolución.",
    "academia.cursos": "Cursos",
    "academia.formaciones": "Formaciones",
    "academia.talleres": "Talleres",
    "academia.aprendizaje": "Aprendizaje continuo",
    "academia.certificaciones": "Certificaciones",
    "academia.cta": "Ir a la Academia",

    // marketplace
    "market.title": "Marketplace KD9",
    "market.body":
      "Productos naturales, tisanas, aceites, jabones, velas y herramientas — un marketplace comunitario de creadores conscientes.",
    "market.cta": "Entrar al Marketplace",

    // contacto
    "contact.title": "Contáctanos",
    "contact.subtitle":
      "Estamos aquí para acompañarte. Escríbenos por el canal que prefieras.",
    "contact.name": "Nombre completo",
    "contact.email": "Correo electrónico",
    "contact.phone": "Teléfono",
    "contact.message": "Mensaje",
    "contact.send": "Enviar mensaje",

    // footer
    "footer.lema": "No vendemos respuestas. Construimos procesos.",
    "footer.contact": "Contacto",
    "footer.follow": "Síguenos",
    "footer.links": "Enlaces",
    "footer.policies": "Políticas",
    "footer.faq": "Preguntas frecuentes",
    "footer.terms": "Términos y condiciones",
    "footer.privacy": "Política de privacidad",
    "footer.whatsapp": "Escríbenos por WhatsApp",

    // common
    "common.learnmore": "Saber más",
    "common.ver": "Ver más",

    // Topbar / Layout
    "topbar.search": "Buscar estudios, productos, cursos…",
    "topbar.greeting": "Hola, {name}",
    "topbar.notifications": "Notificaciones",
    "topbar.help": "¿Necesitas ayuda?",
    "topbar.helpHint": "El equipo Soporte KD9 está disponible 24/7.",
    "topbar.role.user": "Usuario",
    "topbar.role.estudiante": "Estudiante",
    "topbar.role.consultor": "Consultor",
    "topbar.role.creador": "Creador",
    "topbar.role.admin": "Administrador",
    "topbar.role.superadmin": "Director KD9",
    "topbar.role.soporte": "Soporte KD9",

    // Sidebar — section headers
    "sidebar.section.acompanamiento": "Acompañamiento humano",
    "sidebar.section.proceso": "Mi proceso",
    "sidebar.section.cuenta": "Cuenta",
    "sidebar.section.academia": "Academia",
    "sidebar.section.acompanamientoBasic": "Acompañamiento",
    "sidebar.section.operacion": "Operación",
    "sidebar.section.acompanamientoActive": "Acompañamiento (si activo)",
    "sidebar.section.marketplace": "Marketplace",
    "sidebar.section.operacionKD9": "Operación KD9",
    "sidebar.section.pagosRevision": "Pagos (revisión)",
    "sidebar.section.soporte": "Soporte",
    "sidebar.section.nucleo": "Núcleo · Control total",
    "sidebar.section.financiero": "Financiero & Acceso",
    "sidebar.section.equipo": "Equipo & Roles",
    "sidebar.section.contenido": "Contenido & Comercio",
    "sidebar.section.tickets": "Tickets",
    "sidebar.section.asistencia": "Asistencia",
    "sidebar.support": "Soporte KD9",
    "sidebar.logout": "Cerrar sesión",

    // Sidebar — item labels (used across all roles)
    "menu.acompanamiento": "Acompañamiento",
    "menu.hablar": "Hablar con alguien",
    "menu.dashboard": "Dashboard",
    "menu.solicitarDiag": "Solicitar diagnóstico",
    "menu.misDiag": "Mis diagnósticos",
    "menu.academia": "Academia KD9",
    "menu.tienda": "Marketplace",
    "menu.agenda": "Agenda",
    "menu.misSolicitudes": "Mis solicitudes",
    "menu.perfil": "Perfil",
    "menu.soporte": "Soporte KD9",
    "menu.misEstudios": "Mis estudios",
    "menu.progreso": "Progreso",
    "menu.examenes": "Exámenes",
    "menu.materiales": "Materiales",
    "menu.bolsa": "Bolsa de consultas",
    "menu.misTrabajos": "Mis trabajos",
    "menu.informes": "Informes enviados",
    "menu.misProductos": "Mis productos",
    "menu.subirProducto": "Subir producto",
    "menu.pedidosMkt": "Pedidos marketplace",
    "menu.ventas": "Ventas",
    "menu.ganancias": "Ganancias",
    "menu.asignaciones": "Gestión de asignaciones",
    "menu.revisionDiag": "Revisión diagnósticos",
    "menu.solicitudesRoles": "Solicitudes de roles",
    "menu.moderacionUsuarios": "Moderación de usuarios",
    "menu.agendaGlobal": "Agenda global",
    "menu.acompanamientosAdmin": "Acompañamientos",
    "menu.revisionPagos": "Revisión de pagos",
    "menu.ticketsSoporte": "Tickets soporte",
    "menu.dashDirector": "Dashboard Director",
    "menu.configGlobal": "Configuración global",
    "menu.auditoria": "Logs de auditoría",
    "menu.iaKD9": "IA KD9",
    "menu.analitica": "Analítica global",
    "menu.pagos": "Pagos",
    "menu.premium": "Premium",
    "menu.administradores": "Administradores",
    "menu.rolesPerm": "Roles & permisos",
    "menu.consultores": "Consultores",
    "menu.usuarios": "Usuarios",
    "menu.diagnosticos": "Diagnósticos",
    "menu.academiaMgmt": "Academia",
    "menu.marketplaceMgmt": "Marketplace",
    "menu.bolsaGlobal": "Bolsa global",
    "menu.soporteGestion": "Soporte (gestión)",
    "menu.dashSoporte": "Dashboard soporte",
    "menu.ticketsAbiertos": "Tickets abiertos",
    "menu.ticketsEscalados": "Tickets escalados",
    "menu.ticketsCerrados": "Tickets cerrados",
    "menu.usuariosProblemas": "Usuarios con problemas",
    "menu.reportesTecnicos": "Reportes técnicos",
    "menu.escalar": "Escalar caso",

    // Dashboards — common
    "dash.kpi.users": "Usuarios activos",
    "dash.kpi.revenue": "Ingresos mes",
    "dash.kpi.growth": "Crecimiento MoM",
    "dash.kpi.health": "Salud del sistema",
    "dash.kpi.stable": "estable",
    "dash.director.kicker": "· Director KD9 · Núcleo ·",
    "dash.director.title": "DASHBOARD DIRECTOR",
    "dash.director.desc": "Control estratégico total — ingresos, crecimiento, auditoría e IA. Decisiones que el Administrador no puede tomar.",
    "dash.director.control": "Control exclusivo del Director",
    "dash.director.recentAudit": "Auditoría reciente",
    "dash.admin.kicker": "· Administrador · Panel operativo ·",
    "dash.admin.title": "PANEL OPERATIVO ADMIN",
    "dash.admin.desc": "Tu día a día como Administrador: aprobaciones y acompañamiento operativo del equipo KD9.",
    "dash.admin.agenda": "Agenda · Operación de hoy",
    "dash.admin.notice": "Como Administrador puedes revisar pagos y dejar observaciones internas, pero no aprobar/rechazar pagos ni activar Premium. La activación Premium, la aprobación o rechazo de pagos, la configuración global, los logs de auditoría y la IA KD9 son potestad exclusiva del Director KD9.",

    // StubPage default
    "stub.kicker": "KD9",
    "stub.title": "PRÓXIMAMENTE",
    "stub.desc": "Esta sección estará disponible próximamente.",

    // Auth
    "auth.login.title": "INICIAR SESIÓN EN KD9",
    "auth.login.subtitle": "Bienvenido de nuevo",
    "auth.login.email": "Correo electrónico",
    "auth.login.password": "Contraseña",
    "auth.login.remember": "Recordarme",
    "auth.login.forgot": "¿Olvidaste tu contraseña?",
    "auth.login.submit": "Iniciar Sesión",
    "auth.login.loading": "Iniciando...",
    "auth.login.error": "No se pudo iniciar sesión",
    "auth.register.title": "CREAR CUENTA EN KD9",
    "auth.register.subtitle": "Accede a estudios, consultas, academia y tienda energética.",
    "auth.register.name": "Nombre completo",
    "auth.register.phone": "Número de teléfono",
    "auth.register.confirm": "Confirmar contraseña",
    "auth.register.dob": "Fecha de nacimiento (opcional)",
    "auth.register.howUse": "¿Cómo deseas usar KD9?",
    "auth.register.terms": "Acepto términos y condiciones",
    "auth.register.privacy": "Acepto política de privacidad",
    "auth.register.submit": "Crear Cuenta",
    "auth.register.loading": "Creando...",
    "auth.register.error": "No se pudo crear la cuenta",
    "auth.register.haveAcct": "¿Ya tienes cuenta?",
    "auth.register.signIn": "Iniciar sesión",

    // Common buttons / states
    "btn.save": "Guardar",
    "btn.cancel": "Cancelar",
    "btn.send": "Enviar",
    "btn.approve": "Aprobar",
    "btn.reject": "Rechazar",
    "btn.viewDetails": "Ver detalles",
    "btn.observation": "Observación",
    "state.pending": "Pendiente",
    "state.approved": "Aprobado",
    "state.rejected": "Rechazado",
    "state.underReview": "En revisión",
    "toast.comingSoon": "Disponible próximamente",
  },

  en: {
    // nav
    "nav.inicio": "Home",
    "nav.diagnosticos": "Diagnostics",
    "nav.academia": "Academy",
    "nav.acompanamiento": "Guidance",
    "nav.marketplace": "Marketplace",
    "nav.sobre": "About",
    "nav.contacto": "Contact",
    "nav.login": "Sign In",
    "nav.register": "Sign Up",

    // hero
    "hero.kicker": "KD9 Platform · Awaken the ancestral",
    "hero.title": "KHAOS DELTA 9",
    "hero.tagline": "The energy that awakens the ancestral",
    "hero.subtitle":
      "Ancestral knowledge, human guidance, personalized diagnostics, and technology — integrated into a single experience to guide your transformation journey.",
    "hero.cta.solicitar": "Request a Diagnostic",
    "hero.cta.consulta": "Quick Consultation",
    "hero.cta.tienda": "Explore Marketplace",

    // landing sections
    "section.diagnosticos": "Our Diagnostics",
    "section.process": "More than a consultation, a process of clarity",
    "section.how": "How it works",
    "section.whatis": "What is KHAOS DELTA 9?",
    "section.acompanamiento": "Human Companionship",
    "section.academia": "KD9 Academy",
    "section.marketplace": "KD9 Marketplace",
    "section.cta": "Your process begins the moment you decide to look within.",

    "landing.badge.geometry": "Sacred geometry",
    "landing.badge.vision": "Inner vision",
    "landing.badge.nature": "Nature",
    "landing.studies": "Our studies",
    "landing.process.personalized": "Personalized diagnostics",
    "landing.process.professional": "Professional interpretation",
    "landing.process.spiritual": "Spiritual and therapeutic integration",
    "landing.process.delivery": "Clear and structured delivery",
    "landing.step.1.title": "Choose your study",
    "landing.step.1.desc": "Select the study you need.",
    "landing.step.2.title": "Complete your information",
    "landing.step.2.desc": "Provide the information needed to personalize your study.",
    "landing.step.3.title": "Receive your diagnostic",
    "landing.step.3.desc": "Our team analyzes and delivers your study.",
    "landing.step.4.title": "Apply your process",
    "landing.step.4.desc": "Integrate and transform your energy.",
    "landing.academy.subtitle": "Learn, understand and transform your energy.",
    "landing.shop.title": "KD9 STORE",
    "landing.shop.subtitle": "Products created by our community.",
    "landing.shop.cta": "Enter the store",
    "landing.final": "YOUR PROCESS BEGINS|WHEN YOU CHOOSE TO LOOK|WITHIN.",
    "landing.create": "Create an account now",
    "contact.whatsappSend": "Send through WhatsApp",
    "contact.phoneWhatsapp": "Phone and WhatsApp",
    "contact.location": "Location",
    "contact.whatsappStart": "Start a WhatsApp conversation",

    // what is
    "whatis.khaos.title": "KHAOS",
    "whatis.khaos.desc": "Transformation",
    "whatis.delta.title": "DELTA",
    "whatis.delta.desc": "Change",
    "whatis.nine.title": "9",
    "whatis.nine.desc": "Integration",
    "whatis.message": "The energy that awakens the ancestral.",

    // acompañamiento
    "acomp.kicker": "KD9 Companionship",
    "acomp.title": "You are not alone in the process.",
    "acomp.subtitle":
      "Real people, professionals, and ancestral guides — available when you need to listen and be heard.",
    "acomp.hablar": "Talk to someone",
    "acomp.hablar.desc": "Direct conversation with a KD9 consultant.",
    "acomp.video": "Video call",
    "acomp.video.desc": "Private video session with a guide.",
    "acomp.escuchado": "I need to be heard",
    "acomp.escuchado.desc": "A judgement-free space, anytime.",
    "acomp.agendar": "Schedule companionship",
    "acomp.agendar.desc": "Plan an in-depth session with your consultant.",

    // about
    "about.kicker": "About Us",
    "about.title": "Where the ancestral and the technological meet",
    "about.body":
      "KHAOS DELTA 9 is an ecosystem that integrates ancestral knowledge, human guidance, and technology to bring transformation processes closer to people.",
    "about.mision.title": "Mission",
    "about.mision.body":
      "To support human processes through personalized diagnostics, education, community, and professional companionship.",
    "about.vision.title": "Vision",
    "about.vision.body":
      "To become an integral platform where technology and ancestral knowledge coexist.",
    "about.valores": "Values",
    "val.humanidad": "Humanity",
    "val.etica": "Ethics",
    "val.acompanamiento": "Companionship",
    "val.conocimiento": "Knowledge",
    "val.responsabilidad": "Responsibility",
    "val.evolucion": "Evolution",

    // diagnóstico cards
    "diag.egipcio.name": "Egyptian Diagnostic",
    "diag.egipcio.desc": "Connection with your ancestral soul and life purpose.",
    "diag.esencial.name": "Essential Diagnostic",
    "diag.esencial.desc": "Essential energetic analysis for your well-being.",
    "diag.holistico.name": "Holistic Diagnostic",
    "diag.holistico.desc": "Complete evaluation of your energy, body, mind, and spirit.",
    "diag.terreno.name": "Terrain Diagnostic",
    "diag.terreno.desc": "Analysis of your environment and earthly connections.",
    "diag.maestro.name": "Master KD9 Diagnostic",
    "diag.maestro.desc": "The most complete and profound study across all levels.",
    "diag.consulta.name": "Quick Consultation",
    "diag.consulta.desc": "Solve specific doubts with an available consultant.",
    "diag.cta": "Request",
    "diag.from": "From",

    // academia
    "academia.title": "KD9 Academy",
    "academia.body":
      "Courses, training programs, workshops, learning, and certifications — all in one space for your evolution.",
    "academia.cursos": "Courses",
    "academia.formaciones": "Trainings",
    "academia.talleres": "Workshops",
    "academia.aprendizaje": "Continuous learning",
    "academia.certificaciones": "Certifications",
    "academia.cta": "Go to the Academy",

    // marketplace
    "market.title": "KD9 Marketplace",
    "market.body":
      "Natural products, herbal teas, oils, soaps, candles, and tools — a community marketplace of conscious creators.",
    "market.cta": "Enter the Marketplace",

    // contacto
    "contact.title": "Get in touch",
    "contact.subtitle":
      "We are here to accompany you. Write to us through your preferred channel.",
    "contact.name": "Full name",
    "contact.email": "Email",
    "contact.phone": "Phone",
    "contact.message": "Message",
    "contact.send": "Send message",

    // footer
    "footer.lema": "We don't sell answers. We build processes.",
    "footer.contact": "Contact",
    "footer.follow": "Follow us",
    "footer.links": "Links",
    "footer.policies": "Policies",
    "footer.faq": "Frequently asked questions",
    "footer.terms": "Terms and conditions",
    "footer.privacy": "Privacy policy",
    "footer.whatsapp": "Write us on WhatsApp",

    // common
    "common.learnmore": "Learn more",
    "common.ver": "View more",

    // Topbar / Layout
    "topbar.search": "Search studies, products, courses…",
    "topbar.greeting": "Hello, {name}",
    "topbar.notifications": "Notifications",
    "topbar.help": "Need help?",
    "topbar.helpHint": "The KD9 Support team is available 24/7.",
    "topbar.role.user": "User",
    "topbar.role.estudiante": "Student",
    "topbar.role.consultor": "Consultant",
    "topbar.role.creador": "Creator",
    "topbar.role.admin": "Administrator",
    "topbar.role.superadmin": "KD9 Director",
    "topbar.role.soporte": "KD9 Support",

    // Sidebar — section headers
    "sidebar.section.acompanamiento": "Human companionship",
    "sidebar.section.proceso": "My process",
    "sidebar.section.cuenta": "Account",
    "sidebar.section.academia": "Academy",
    "sidebar.section.acompanamientoBasic": "Companionship",
    "sidebar.section.operacion": "Operations",
    "sidebar.section.acompanamientoActive": "Companionship (if active)",
    "sidebar.section.marketplace": "Marketplace",
    "sidebar.section.operacionKD9": "KD9 Operations",
    "sidebar.section.pagosRevision": "Payments (review)",
    "sidebar.section.soporte": "Support",
    "sidebar.section.nucleo": "Core · Full control",
    "sidebar.section.financiero": "Finance & Access",
    "sidebar.section.equipo": "Team & Roles",
    "sidebar.section.contenido": "Content & Commerce",
    "sidebar.section.tickets": "Tickets",
    "sidebar.section.asistencia": "Assistance",
    "sidebar.support": "KD9 Support",
    "sidebar.logout": "Logout",

    // Sidebar — item labels
    "menu.acompanamiento": "Companionship",
    "menu.hablar": "Talk to someone",
    "menu.dashboard": "Dashboard",
    "menu.solicitarDiag": "Request diagnostic",
    "menu.misDiag": "My diagnostics",
    "menu.academia": "KD9 Academy",
    "menu.tienda": "Marketplace",
    "menu.agenda": "Schedule",
    "menu.misSolicitudes": "My requests",
    "menu.perfil": "Profile",
    "menu.soporte": "KD9 Support",
    "menu.misEstudios": "My studies",
    "menu.progreso": "Progress",
    "menu.examenes": "Exams",
    "menu.materiales": "Materials",
    "menu.bolsa": "Consultation pool",
    "menu.misTrabajos": "My work",
    "menu.informes": "Submitted reports",
    "menu.misProductos": "My products",
    "menu.subirProducto": "Upload product",
    "menu.pedidosMkt": "Marketplace orders",
    "menu.ventas": "Sales",
    "menu.ganancias": "Earnings",
    "menu.asignaciones": "Assignment management",
    "menu.revisionDiag": "Diagnostics review",
    "menu.solicitudesRoles": "Role requests",
    "menu.moderacionUsuarios": "User moderation",
    "menu.agendaGlobal": "Global schedule",
    "menu.acompanamientosAdmin": "Companionships",
    "menu.revisionPagos": "Payments review",
    "menu.ticketsSoporte": "Support tickets",
    "menu.dashDirector": "Director Dashboard",
    "menu.configGlobal": "Global settings",
    "menu.auditoria": "Audit logs",
    "menu.iaKD9": "KD9 AI",
    "menu.analitica": "Global analytics",
    "menu.pagos": "Payments",
    "menu.premium": "Premium",
    "menu.administradores": "Administrators",
    "menu.rolesPerm": "Roles & permissions",
    "menu.consultores": "Consultants",
    "menu.usuarios": "Users",
    "menu.diagnosticos": "Diagnostics",
    "menu.academiaMgmt": "Academy",
    "menu.marketplaceMgmt": "Marketplace",
    "menu.bolsaGlobal": "Global pool",
    "menu.soporteGestion": "Support (management)",
    "menu.dashSoporte": "Support Dashboard",
    "menu.ticketsAbiertos": "Open tickets",
    "menu.ticketsEscalados": "Escalated tickets",
    "menu.ticketsCerrados": "Closed tickets",
    "menu.usuariosProblemas": "Users with issues",
    "menu.reportesTecnicos": "Technical reports",
    "menu.escalar": "Escalate case",

    // Dashboards — common
    "dash.kpi.users": "Active users",
    "dash.kpi.revenue": "Monthly revenue",
    "dash.kpi.growth": "MoM growth",
    "dash.kpi.health": "System health",
    "dash.kpi.stable": "stable",
    "dash.director.kicker": "· KD9 Director · Core ·",
    "dash.director.title": "DIRECTOR DASHBOARD",
    "dash.director.desc": "Total strategic control — revenue, growth, audit and AI. Decisions the Administrator cannot make.",
    "dash.director.control": "Director's exclusive control",
    "dash.director.recentAudit": "Recent audit",
    "dash.admin.kicker": "· Administrator · Operational panel ·",
    "dash.admin.title": "ADMIN OPERATIONAL PANEL",
    "dash.admin.desc": "Your day-to-day as Administrator: approvals and operational support for the KD9 team.",
    "dash.admin.agenda": "Schedule · Today's operations",
    "dash.admin.notice": "As Administrator you can review payments and leave internal observations, but you cannot approve/reject payments nor activate Premium. Premium activation, payment approval/rejection, global settings, audit logs and KD9 AI are exclusive to the KD9 Director.",

    // StubPage default
    "stub.kicker": "KD9",
    "stub.title": "COMING SOON",
    "stub.desc": "This section will be available soon.",

    // Auth
    "auth.login.title": "SIGN IN TO KD9",
    "auth.login.subtitle": "Welcome back",
    "auth.login.email": "Email",
    "auth.login.password": "Password",
    "auth.login.remember": "Remember me",
    "auth.login.forgot": "Forgot your password?",
    "auth.login.submit": "Sign In",
    "auth.login.loading": "Signing in...",
    "auth.login.error": "Sign in failed",
    "auth.register.title": "CREATE A KD9 ACCOUNT",
    "auth.register.subtitle": "Access studies, consultations, academy and energetic store.",
    "auth.register.name": "Full name",
    "auth.register.phone": "Phone number",
    "auth.register.confirm": "Confirm password",
    "auth.register.dob": "Date of birth (optional)",
    "auth.register.howUse": "How do you want to use KD9?",
    "auth.register.terms": "I accept terms and conditions",
    "auth.register.privacy": "I accept the privacy policy",
    "auth.register.submit": "Create Account",
    "auth.register.loading": "Creating...",
    "auth.register.error": "Account could not be created",
    "auth.register.haveAcct": "Already have an account?",
    "auth.register.signIn": "Sign in",

    // Common buttons / states
    "btn.save": "Save",
    "btn.cancel": "Cancel",
    "btn.send": "Send",
    "btn.approve": "Approve",
    "btn.reject": "Reject",
    "btn.viewDetails": "View details",
    "btn.observation": "Observation",
    "state.pending": "Pending",
    "state.approved": "Approved",
    "state.rejected": "Rejected",
    "state.underReview": "Under review",
    "toast.comingSoon": "Coming soon",
  },
};
